import React from "react";
import "./HeroBanner.scss";
import useWindowDimensions from "../../Hooks/useViewWidth";

interface Props {
  hero: string;
  title?: React.ReactNode | string;
  width?: number;
  className?: string;
  maxDesktopHeight?: string | number;
  // Mobile-specific props
  mobileHero?: string;
  mobileTitle?: React.ReactNode | string;
  afterBanner?: React.ReactNode | string;
  afterBannerMobile?: React.ReactNode | string;
  mobileMaxHeight?: string | number;
  mobileMinHeight?: string | number;
  mobileBreakpoint?: number;
}
const HeroBannerHorizontal = ({
  hero,
  title,
  width = 50,
  maxDesktopHeight = "auto",
  className,
  mobileHero,
  mobileTitle,
  afterBanner,
  afterBannerMobile,
  mobileMaxHeight,
  mobileMinHeight,
  mobileBreakpoint = 768,
}: Props) => {
  const { isSmaller: isMobile } = useWindowDimensions(mobileBreakpoint);

  const currentHero = isMobile && mobileHero ? mobileHero : hero;
  const currentTitle = isMobile && mobileTitle ? mobileTitle : title;
  const currentAfterBanner = isMobile && afterBannerMobile ? afterBannerMobile : afterBanner;
  const currentMaxHeight = isMobile && mobileMaxHeight ? mobileMaxHeight : maxDesktopHeight;
  const currentMinHeight = isMobile && mobileMinHeight ? mobileMinHeight : undefined;

  return (
    <>
      <div
        className={`heroBannerMain ${className || ""} ${isMobile ? "heroBannerMobile" : ""}`}
        style={{
          backgroundImage: `url(${currentHero})`,
          maxHeight:
            typeof currentMaxHeight === "number"
              ? `${currentMaxHeight}px`
              : currentMaxHeight,
          minHeight:
            currentMinHeight
              ? typeof currentMinHeight === "number"
                ? `${currentMinHeight}px`
                : currentMinHeight
              : undefined,
        }}
      >
        {currentTitle && (
          <h1
            className="heroBannerHorizontalTitle"
            style={{ width: isMobile ? "100%" : `${width}%` }}
          >
            {currentTitle}
          </h1>
        )}
      </div>

      {currentAfterBanner && (
        <div className="heroBannerAfter">
          {currentAfterBanner}
        </div>
      )}
    </>
  );
};
export default HeroBannerHorizontal;
